import { render, staticRenderFns } from "./ButtonPromise.vue?vue&type=template&id=3b4d5e0a&"
import script from "./ButtonPromise.vue?vue&type=script&lang=js&"
export * from "./ButtonPromise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports